import { Action } from 'redux';
import { DeskGroupModel } from '../../../api/core/core.types';
import { Page } from '../../../api/api.types';

export const GET_DESK_GROUP_LIST = 'GET_DESK_GROUP_LIST';
export const GET_DESK_GROUP = 'GET_DESK_GROUP';
export const PUT_DESK_GROUP = 'PUT_DESK_GROUP';
export const POST_DESK_GROUP = 'POST_DESK_GROUP';
export const DELETE_DESK_GROUP = 'DELETE_DESK_GROUP';

export interface DeskGroupState {
  deskGroups: DeskGroupModel[] | [];
  selectedDeskGroup: DeskGroupModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
}

export interface GetDeskGroupListAction extends Action {
  type: typeof GET_DESK_GROUP_LIST;
  payload: {
    page: Page<DeskGroupModel>;
  };
}

export interface GetDeskGroupAction extends Action {
  type: typeof GET_DESK_GROUP;
  payload: {
    selectedDeskGroup: DeskGroupModel | null;
  };
}

export interface PutDeskGroupAction extends Action {
  type: typeof PUT_DESK_GROUP;
  payload: {
    selectedDeskGroup: DeskGroupModel;
  };
}

export interface PostDeskGroupAction extends Action {
  type: typeof POST_DESK_GROUP;
  payload: {
    newDeskGroup: DeskGroupModel;
    success: boolean;
  };
}

export interface DeleteDeskGroupAction extends Action {
  type: typeof DELETE_DESK_GROUP;
  payload: {
    success: boolean;
  };
}

export type DeskGroupActionTypes = GetDeskGroupListAction | GetDeskGroupAction | PutDeskGroupAction | PostDeskGroupAction | DeleteDeskGroupAction;
